import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackEvent } from "@/utils/analytics";
import SEO from "@/components/SEO";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    trackEvent('page_not_found', { url: window.location.pathname });
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <SEO title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-gray-600">Oops! Page not found</p>
        <a href="/" className="text-blue-500 underline hover:text-blue-700">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
